var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as React from 'react';
import dayjs from 'dayjs';
import { useEmptyFridgeAlternativeMealApi, useGetCustomerApi, useGetPersonApi, useSaveEmptyFridgePlanApi, } from '../../hooks';
export var useEmptyFridgePlanFacade = function (plan, ingredientsIds, onSaveSuccess) {
    var _a = React.useState(plan), mutablePlan = _a[0], setMutablePlan = _a[1];
    var _b = React.useState({}), cachedAlternatives = _b[0], setCachedAlternatives = _b[1];
    var dates = React.useMemo(function () {
        var planDates = mutablePlan.plans.map(function (p) { return p.currentDate; });
        if (planDates.length === 0) {
            return { minDate: '', maxDate: '' };
        }
        var sortedDates = planDates.sort();
        return {
            minDate: dayjs(sortedDates[0]).format('YYYY-MM-DD'),
            maxDate: dayjs(sortedDates[sortedDates.length - 1]).format('YYYY-MM-DD'),
        };
    }, [mutablePlan.plans]);
    var _c = React.useState(dates.minDate), selectedDate = _c[0], setSelectedDate = _c[1];
    var saveEmptyFridgePlan = useSaveEmptyFridgePlanApi().mutateAsync;
    var customer = useGetCustomerApi().data;
    var person = useGetPersonApi(customer === null || customer === void 0 ? void 0 : customer.personId).data;
    var _d = useEmptyFridgeAlternativeMealApi(), generateAlternativeMeal = _d.mutateAsync, isGenerateAlternativeMealLoading = _d.isLoading;
    var confirmPlan = React.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(person === null || person === void 0 ? void 0 : person.familyId)) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, saveEmptyFridgePlan({
                            familyId: person.familyId,
                            plans: mutablePlan.plans,
                        })];
                case 1:
                    _a.sent();
                    onSaveSuccess();
                    return [2 /*return*/];
            }
        });
    }); }, [onSaveSuccess, person === null || person === void 0 ? void 0 : person.familyId, mutablePlan.plans, saveEmptyFridgePlan]);
    var onGenerateAlternativeMealPress = React.useCallback(function (mealType, date) { return __awaiter(void 0, void 0, void 0, function () {
        var updatePlan, updateCachedAlternatives, cachedAlternativesFiltered, cachedAlternativeCopy, substituteRecipe, planParam, result, alternativesFromApi, apiSubstituteRecipe;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!(person === null || person === void 0 ? void 0 : person.familyId)) {
                        return [2 /*return*/];
                    }
                    updatePlan = function (alternativeRecipe) {
                        setMutablePlan(function (prev) { return (__assign(__assign({}, prev), { plans: prev.plans.map(function (p) {
                                var _a;
                                return p.currentDate === date
                                    ? __assign(__assign({}, p), { result: __assign(__assign({}, p.result), (_a = {}, _a[mealType] = alternativeRecipe, _a)) }) : p;
                            }) })); });
                    };
                    updateCachedAlternatives = function (cachedAlternativeCopy) {
                        setCachedAlternatives(function (prev) {
                            var _a, _b, _c, _d;
                            if (cachedAlternativeCopy.length === 0) {
                                return __assign(__assign({}, prev), (_a = {}, _a[date] = __assign(__assign({}, prev[date]), (_b = {}, _b[mealType] = undefined, _b)), _a));
                            }
                            return __assign(__assign({}, prev), (_c = {}, _c[date] = __assign(__assign({}, prev[date]), (_d = {}, _d[mealType] = cachedAlternativeCopy, _d)), _c));
                        });
                    };
                    cachedAlternativesFiltered = (_a = cachedAlternatives[date]) === null || _a === void 0 ? void 0 : _a[mealType];
                    if (cachedAlternativesFiltered && cachedAlternativesFiltered.length > 0) {
                        cachedAlternativeCopy = __spreadArray([], cachedAlternativesFiltered, true);
                        substituteRecipe = cachedAlternativeCopy.shift();
                        updateCachedAlternatives(cachedAlternativeCopy);
                        if (substituteRecipe) {
                            updatePlan(substituteRecipe);
                        }
                        return [2 /*return*/];
                    }
                    planParam = mutablePlan.plans.find(function (p) { return p.currentDate === date; });
                    if (!planParam) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, generateAlternativeMeal({
                            familyId: person.familyId,
                            mealType: mealType,
                            plan: planParam,
                            ingredientsIds: ingredientsIds,
                            isSeasonal: true, // ← Aggiunto parametro isSeasonal hardcodato a true
                        })];
                case 1:
                    result = _b.sent();
                    alternativesFromApi = __spreadArray([], result.alternatives, true);
                    apiSubstituteRecipe = alternativesFromApi.shift();
                    if (apiSubstituteRecipe) {
                        updatePlan(apiSubstituteRecipe);
                        updateCachedAlternatives(alternativesFromApi);
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [
        person === null || person === void 0 ? void 0 : person.familyId,
        cachedAlternatives,
        mutablePlan.plans,
        generateAlternativeMeal,
        ingredientsIds,
    ]);
    return {
        dates: dates,
        selectedDate: selectedDate,
        setSelectedDate: setSelectedDate,
        confirmPlan: confirmPlan,
        mutablePlan: mutablePlan,
        setMutablePlan: setMutablePlan,
        isGenerateAlternativeMealLoading: isGenerateAlternativeMealLoading,
        onGenerateAlternativeMealPress: onGenerateAlternativeMealPress,
    };
};
